import InfoIcon from "../../../../../images/info-icon.png";
import { useAppDispatch } from "hooks/hooks";
import {
  getPayablesFinancialCard,
  selectState,
  setNewAccountPayablePopover
} from "../accountPayable.slice";
import Popover from "components/Popover/Popover";
import { useSelector } from "react-redux";
import NewAccountPayablePopover from "./NewAccountPayablePopover";
import { useRef, useState } from "react";
import { IPopoverState } from "Dashboard/scenes/Carnets/domain/IPopoverState";
import { PayablesAdditionalInfoPopover } from "./PayablesAdditionalInfoPopover";
import { selectPartner } from "../../Main/main.slice";
import { IFinancialCard } from "Dashboard/scenes/Partners/domain/payables/IFinancialCard";
import PrintPayablesFinancialCard from "./PrintPayablesFinancialCard";
import ToolboxButton, { ToolboxButtonIcon } from "Dashboard/components/Buttons/ToolboxButton";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasWriteAccessTo } from "utils/authUtil";
import { PARTNER_MODULE_NAME } from "Dashboard/scenes/Partners/domain/PartnerModule";
import { usePagePrint } from "hooks/usePagePrint";

const AccountPayableHeader = () => {
  const dispatch = useAppDispatch();
  const { newAccountPayablePopover } = useSelector(selectState);
  const { user } = useSelector(selectStateAuth);
  const [additionalInfoPopover, setAdditionalInfoPopover]
    = useState<IPopoverState>({
      isOpen: false,
      top: 0,
      left: 0,
    });
  const componentRefFinancialCard = useRef<HTMLDivElement>(null);
  const [partnerIdToPrintFinancialCard, setPartnerIdToPrintFinancialCard]
    = useState<number | null>(null);

  const partner = useSelector(selectPartner);

  const handlePrintFinancialCard = usePagePrint(componentRefFinancialCard);

  const printFinancialCard = (partnerId: number) => {
    setPartnerIdToPrintFinancialCard(partnerId);
    dispatch(getPayablesFinancialCard(partnerId));
  };

  const doPrintFinancialCard = (financialCard: IFinancialCard | undefined) => {
    if (partnerIdToPrintFinancialCard === financialCard?.partnerId) {
      handlePrintFinancialCard();
      setPartnerIdToPrintFinancialCard(null);
    }
  }

  return (
    <div className="header">
      <span className="text">Mi plaćamo</span>
      <span className="icon">
        <img src={InfoIcon} alt=""
          onClick={(e) => setAdditionalInfoPopover({
            isOpen: true, top: e.clientY + 5, left: e.clientX
          })}
        />
      </span>
      <span className="rightButtons">
        <ToolboxButton
          icon={ToolboxButtonIcon.Print}
          onClick={(e) => printFinancialCard(partner.partnerId)}
          tooltip="Štampa finansijske kartice dugovanja"
        />
        <ToolboxButton
          icon={ToolboxButtonIcon.ArrowCircleDown}
          onClick={hasWriteAccessTo(user, PARTNER_MODULE_NAME)
            ? (e) => dispatch(setNewAccountPayablePopover({
              isOpen: true, top: e.clientY + 5, left: e.clientX
            })) : undefined}
          tooltip="Nova faktura"
        />
      </span>
      <Popover
        isOpen={newAccountPayablePopover.isOpen}
        onClose={() => {
          dispatch(setNewAccountPayablePopover({
            isOpen: false
          }))
        }}
        direction="left"
        title="Mi plaćamo - nova faktura"
        arrowStyle={{ top: '40%' }}
        position={{
          top: newAccountPayablePopover.top,
          left: newAccountPayablePopover.left,
          offsetLeft: -330,
          offsetTop: -125
        }}
      >
        <NewAccountPayablePopover />
      </Popover>
      <Popover
        isOpen={additionalInfoPopover.isOpen}
        onClose={() => { setAdditionalInfoPopover({ isOpen: false }) }}
        direction="right"
        title="Info"
        arrowStyle={{ top: '40%' }}
        position={{
          top: additionalInfoPopover.top,
          left: additionalInfoPopover.left,
          offsetLeft: 20,
          offsetTop: -190
        }}
      >
        <PayablesAdditionalInfoPopover />
      </Popover>
      <div ref={componentRefFinancialCard} className="print-area">
        <PrintPayablesFinancialCard doPrint={doPrintFinancialCard} />
      </div>
    </div>
  );
};

export default AccountPayableHeader;
